(() => {
  const selectorName = '[data-costco-special-selector]';
  const ga4MeasurementId = 'G-16X76WCNK7';

  const trackGa4Event = (eventName, params = {}) => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, {
      ...params,
      send_to: ga4MeasurementId
    });
  };

  const ensureMobileFooterGapFix = () => {
    if (document.getElementById('neos-ii-ultra-1-mobile-footer-gap-fix')) return;
    const style = document.createElement('style');
    style.id = 'neos-ii-ultra-1-mobile-footer-gap-fix';
    style.textContent = `
      @media (max-width: 1024px) {
        body[data-template="product.neos-ii-ultra-1"] .shopify-section:not(.as-main-product-v2):last-child {
          margin-bottom: 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  ensureMobileFooterGapFix();

  const ensureStyleOverrides = () => {
    if (document.getElementById('costco-special-style-overrides')) return;
    const style = document.createElement('style');
    style.id = 'costco-special-style-overrides';
    style.textContent = `
      .costco-set-option[aria-checked="false"] {
        min-height: 0;
        align-items: center;
      }
      .costco-set-pricing {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
      .pb-box-250321.costco-special-active .costco-external-price {
        display: flex !important;
        align-items: baseline !important;
        font-family: inherit;
        font-weight: 700;
        font-size: calc(19.69vh * var(--t) * var(--pc-v2cfts, 1)) !important;
        line-height: 1.1;
        white-space: nowrap;
      }
      .pb-box-250321.costco-special-active .costco-external-compare {
        display: inline-block !important;
        margin-top: 0 !important;
        margin-left: calc(4.8vh * var(--t)) !important;
        font-family: inherit;
        font-weight: 500 !important;
        font-size: calc(16vh * var(--t) * var(--pc-v2cfts, 1)) !important;
        line-height: 1 !important;
        color: #6E6E73 !important;
        text-decoration: line-through;
        white-space: nowrap;
      }
      .costco-external-cta {
        height: calc(38vh * var(--t));
        font-size: calc(16vh * var(--t) * var(--pc-v2cfts, 1));
      }
      @media (max-width: 1024px) {
        .pb-box-250321.costco-special-active .costco-external-price {
          font-size: 5.4vw !important;
        }
        .pb-box-250321.costco-special-active .costco-external-compare {
          margin-left: 0.4em !important;
          font-size: 3.6vw !important;
        }
        .pb-box-250321.costco-special-active .costco-external-cta {
          width: 44vw !important;
          height: 9.6vw !important;
          font-size: 4.2vw !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const parseConfig = (selector) => {
    const source = selector.querySelector('[data-costco-special-config]');
    if (!source) return null;
    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      return null;
    }
  };

  const capturePicture = (picture) => {
    if (!picture) return null;
    const image = picture.querySelector('img');
    return {
      sources: Array.from(picture.querySelectorAll('source')).map((source) => source.getAttribute('srcset') || ''),
      image: image ? image.getAttribute('src') || '' : '',
      alt: image ? image.getAttribute('alt') || '' : ''
    };
  };

  const restorePicture = (picture, original) => {
    if (!picture || !original) return;
    Array.from(picture.querySelectorAll('source')).forEach((source, index) => {
      source.setAttribute('srcset', original.sources[index] || '');
    });
    const image = picture.querySelector('img');
    if (image) {
      image.setAttribute('src', original.image);
      image.setAttribute('alt', original.alt);
    }
  };

  const replacePicture = (picture, content, fallbackAlt) => {
    if (!picture || !content) return;
    const desktop = content.desktop || content.mobile || content.thumbnail;
    const mobile = content.mobile || content.desktop || content.thumbnail;
    if (!desktop && !mobile) return;
    Array.from(picture.querySelectorAll('source')).forEach((source) => {
      const media = source.getAttribute('media') || '';
      source.setAttribute('srcset', media.includes('max-width') ? mobile : desktop);
    });
    const image = picture.querySelector('img');
    if (image) {
      image.setAttribute('src', content.thumbnail || desktop || mobile);
      image.setAttribute('alt', content.alt || fallbackAlt || 'Costco Special in-box image');
    }
  };

  const createDock = (loader) => {
    let dock = loader.querySelector('.costco-external-dock');
    if (dock) return dock;
    dock = document.createElement('div');
    dock.className = 'costco-external-dock';
    const price = document.createElement('span');
    price.className = 'costco-external-price';
    const current = document.createElement('span');
    current.className = 'costco-external-current';
    const compare = document.createElement('del');
    compare.className = 'costco-external-compare';
    price.append(current, compare);
    const link = document.createElement('a');
    link.className = 'costco-external-cta';
    link.addEventListener('click', (event) => {
      if (!link.getAttribute('href')) event.preventDefault();
    });
    dock.append(price, link);
    loader.append(dock);
    return dock;
  };

  const initialize = (selector) => {
    if (selector.dataset.costcoInitialized === 'true') return;
    ensureStyleOverrides();
    const config = parseConfig(selector);
    const controls = selector.closest('.pb-box-250321');
    const page = selector.closest('.buy-neos-ii-wrapper');
    if (!config || !controls || !page) return;
    selector.dataset.costcoInitialized = 'true';

    const gallery = page.querySelector('.pb-box-250320');
    const pictures = {
      color1: gallery ? gallery.querySelector('.msiw-5 picture.product-color-1') : null,
      color2: gallery ? gallery.querySelector('.msiw-5 picture.product-color-2') : null
    };
    const thumbnails = {
      color1: gallery ? gallery.querySelector('.s-thumbnail-item.product-color-1[data-swipe-index="4"]') : null,
      color2: gallery ? gallery.querySelector('.s-thumbnail-item.product-color-2[data-swipe-index="4"]') : null
    };
    const originals = {
      pictures: {
        color1: capturePicture(pictures.color1),
        color2: capturePicture(pictures.color2)
      },
      thumbnails: {
        color1: thumbnails.color1 ? thumbnails.color1.getAttribute('src') || '' : '',
        color2: thumbnails.color2 ? thumbnails.color2.getAttribute('src') || '' : ''
      }
    };
    const buttons = Array.from(selector.querySelectorAll('[data-costco-set]'));
    const currentSet = selector.querySelector('[data-costco-current-set]');
    const standardPrice = selector.querySelector('[data-costco-standard-price]');
    const docks = Array.from(controls.querySelectorAll('.pb-bottom-loader')).map(createDock);
    let state = 'standard';

    const colorOptions = () => Array.from(controls.querySelectorAll('.opts-1 .vs-opt-item'));
    const selectedColorIndex = () => {
      const options = colorOptions();
      const selected = controls.querySelector('.opts-1 .vs-opt-item.selected');
      const index = options.indexOf(selected);
      return index === 1 ? 2 : 1;
    };
    const selectedColorName = () => {
      const selected = controls.querySelector('.opts-1 .vs-opt-item.selected');
      return selected ? selected.dataset.value || '' : '';
    };
    const selectedConfig = () => selectedColorIndex() === 2 ? config.color2 : config.color1;
    const trackingParams = () => ({
      product_name: 'NEOS II Ultra',
      set_type: 'exclusive_value_set',
      selected_color: selectedColorName() || 'unknown',
      page_path: window.location.pathname
    });

    const updateStandardPrice = () => {
      if (!standardPrice || !Array.isArray(config.variants)) return;
      const color = selectedColorName();
      const variant = config.variants.find((item) => item.color === color);
      if (variant && variant.price) standardPrice.textContent = variant.price;
    };

    const updateDocks = () => {
      const colorConfig = selectedConfig() || {};
      docks.forEach((dock) => {
        const price = dock.querySelector('.costco-external-current');
        const compare = dock.querySelector('.costco-external-compare');
        const link = dock.querySelector('.costco-external-cta');
        const compareValue = String(config.comparePrice || '').trim();
        price.textContent = config.price || '';
        compare.textContent = compareValue && !compareValue.startsWith('$') ? `$${compareValue}` : compareValue;
        compare.hidden = !compareValue;
        link.textContent = config.ctaLabel || 'Buy on Costco';
        if (colorConfig.url) {
          link.setAttribute('href', colorConfig.url);
          link.removeAttribute('aria-disabled');
        } else {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
        }
        if (config.openNewTab) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        } else {
          link.removeAttribute('target');
          link.removeAttribute('rel');
        }
      });
    };

    const restoreGallery = () => {
      restorePicture(pictures.color1, originals.pictures.color1);
      restorePicture(pictures.color2, originals.pictures.color2);
      if (thumbnails.color1) thumbnails.color1.setAttribute('src', originals.thumbnails.color1);
      if (thumbnails.color2) thumbnails.color2.setAttribute('src', originals.thumbnails.color2);
    };

    const applyCostcoGallery = () => {
      replacePicture(pictures.color1, config.color1, `${config.costcoTitle || 'Costco Special'} Midnight Blue in-box image`);
      replacePicture(pictures.color2, config.color2, `${config.costcoTitle || 'Costco Special'} Champagne Gold in-box image`);
      if (thumbnails.color1 && config.color1.thumbnail) thumbnails.color1.setAttribute('src', config.color1.thumbnail);
      if (thumbnails.color2 && config.color2.thumbnail) thumbnails.color2.setAttribute('src', config.color2.thumbnail);
    };

    const showLastGalleryImage = () => {
      if (window.swiperMain && typeof window.swiperMain.slideTo === 'function') {
        window.swiperMain.slideTo(4);
        return;
      }
      const colorClass = selectedColorIndex() === 2 ? 'product-color-2' : 'product-color-1';
      const thumbnail = gallery ? gallery.querySelector(`.s-thumbnail-item.${colorClass}[data-swipe-index="4"]`) : null;
      if (thumbnail) thumbnail.click();
    };

    const setState = (nextState, moveGallery) => {
      state = nextState;
      const isCostco = state === 'costco';
      controls.classList.toggle('costco-special-active', isCostco);
      page.classList.toggle('costco-special-active', isCostco);
      selector.classList.toggle('is-costco-selected', isCostco);
      buttons.forEach((button) => {
        button.setAttribute('aria-checked', button.dataset.costcoSet === state ? 'true' : 'false');
      });
      if (currentSet) currentSet.textContent = isCostco ? config.costcoTitle : config.standardTitle;
      if (isCostco) {
        applyCostcoGallery();
        updateDocks();
      } else {
        restoreGallery();
      }
      if (moveGallery) requestAnimationFrame(showLastGalleryImage);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const nextState = button.dataset.costcoSet;
        if (nextState === 'costco' && state !== 'costco') {
          trackGa4Event('costco_set_select', trackingParams());
        }
        setState(nextState, true);
      });
    });

    docks.forEach((dock) => {
      const link = dock.querySelector('.costco-external-cta');
      if (!link) return;
      link.addEventListener('click', () => {
        if (!link.getAttribute('href')) return;
        trackGa4Event('costco_continue_click', {
          ...trackingParams(),
          destination: 'costco',
          button_text: link.textContent.trim() || config.ctaLabel || 'Continue to Costco'
        });
      });
    });

    colorOptions().forEach((option) => {
      option.addEventListener('click', () => {
        requestAnimationFrame(() => {
          updateStandardPrice();
          updateDocks();
        });
      });
    });

    updateStandardPrice();
    updateDocks();
    setState(state, false);
    // Auto-select Costco Value Set when URL contains ?set=costco
const urlParams = new URLSearchParams(window.location.search);

if (urlParams.get('set') === 'costco') {
  const costcoButton = buttons.find(
    (button) => button.dataset.costcoSet === 'costco'
  );

  if (
    costcoButton &&
    costcoButton.getAttribute('aria-checked') !== 'true'
  ) {
    requestAnimationFrame(() => {
      costcoButton.click();
    });
  }
}
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(selectorName).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
